import { render } from "./LogManage.vue?vue&type=template&id=22786920"
import script from "./LogManage.vue?vue&type=script&lang=js"
export * from "./LogManage.vue?vue&type=script&lang=js"

import "./LogManage.vue?vue&type=style&index=0&id=22786920&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__